import { Box, Button, Divider, FormControl, Stack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import CanopyButton from '../CanopyButton/CanopyButton';
import CanopyInput from '../CanopyInput/CanopyInput';
import { LoginFlow, LoginPageProps } from './LoginPage';

interface LoginFlowProps extends LoginPageProps {
    setLoginFlow: React.Dispatch<React.SetStateAction<LoginFlow>>;
}
const ForgotPassword: React.FC<LoginFlowProps> = (props) => {
    const currentColors = useCurrentColors();
    const { t } = props;

    const [email, setEmail] = useState('');

    const handleResetLink = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (props.onSendResetLink) {
            props.onSendResetLink(email);
        }
    };

    return (
        <>
            <Box
                color={currentColors.brand['10']}
                fontWeight="bold"
                width="326px"
                mt="4px"
                fontSize="16px"
                textAlign="center">
                <Box
                    mx="auto"
                    width="158px">
                    {t('forgot-password.title')}
                </Box>
                <Box
                    mx="auto"
                    width="348px">
                    {t('forgot-password.sub-title')}
                </Box>
            </Box>
            <Box
                color={currentColors.contentText}
                mx="auto"
                width="300px"
                height="42px"
                fontSize="15px"
                mt="5px"
                textAlign="center">
                {t('forgot-password.message')}
            </Box>
            <Divider
                borderColor={currentColors.brand['700']}
                width="420px"
                my="20px"
            />
            <form onSubmit={handleResetLink}>
                <Stack>
                    <FormControl>
                        <CanopyInput
                            id="emai"
                            placeholder={`${t(
                                'forgot-password.enter-email'
                            )} (e.g john_doe@mail.com)`}
                            label={t('forgot-password.email-address')}
                            height="45px"
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                            ) => setEmail(event.target.value)}></CanopyInput>
                    </FormControl>
                    <CanopyButton
                        type="submit"
                        width={['50%', '50%', '50%', '420px', '420px']}
                        height="45px"
                        mt="42px"
                        isDisabled={!email}>
                        {t('forgot-password.send-reset-link')}
                    </CanopyButton>
                </Stack>
            </form>
            <Button
                fontSize="sm"
                variant="link"
                width={['50%', '50%', '50%', '120px', '120px']}
                height="20px"
                mt="20px"
                color={currentColors.brand['300']}
                _hover={{ textDecoration: 'none' }}
                _focus={{ border: 'none' }}
                onClick={() => props.setLoginFlow('login')}>
                {t('forgot-password.return-to-login')}
            </Button>
        </>
    );
};

export default ForgotPassword;
